module.exports = "<app-transfer *ngIf=\"!error\" [transfer]=\"transfer\">\n</app-transfer>\n\n<div *ngIf=\"error\" class=\"error\">\n  Delivery could not be loaded\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/downloads/download.component.html
// module id = ./src/app/downloads/download.component.html
// module chunks = main